import { Field, useFormikContext } from 'formik';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import selectors from '../../../../store/selectors';
import FormErrorMessage from '../../../Form/formik/FormErrorMessage';

import styles from './SelectPreferredTimeslots.module.scss';

const SelectPreferredTimeslots = ({ name }) => {
  const preferredTimeSlots = useSelector(selectors.getPreferredTimeSlots);
  const { errors } = useFormikContext();

  return (
    <div className="md-form input-group mt-3 flex-column form-outline">
      <Field
        component="select"
        id={name}
        className={classNames('browser-default', 'custom-select', 'mt-5', {
          [`${styles.invalid}`]: errors[name],
        })}
        name={name}
      >
        <option value="" disabled selected>
          Wybierz preferowany termin
        </option>
        {preferredTimeSlots.slots.map(slot => (
          <option key={slot} value={slot}>
            {slot}
          </option>
        ))}
      </Field>
      {/* eslint-disable jsx-a11y/label-has-associated-control */}
      <label className="form-label" htmlFor={name}>
        Preferowany termin
      </label>
      <FormErrorMessage name={name} />
    </div>
  );
};

SelectPreferredTimeslots.propTypes = {
  name: PropTypes.string.isRequired,
};

export default SelectPreferredTimeslots;
